/* eslint-disable */
import "./App.css";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import AppLayout from "./layouts/AppLayout.jsx";
import NotFound from "./NotFound.jsx";
import PrivateRoutes from "./routes/Private.routes.jsx";
import PublicRoutes from "./routes/Public.routes.jsx";
import { useEffect } from "react";

function App() {
  const navigate = useNavigate();

  const location = useLocation();
  useEffect(() => {
    let isRedirect = false;
    let parentName = location.pathname && location.pathname.split("/");
    if (location.pathname === "/" || location.pathname === "") {
      navigate("/organizational/management/dashboard", { state: "Management" });
    } else {
      parentName =
        (parentName !== "" && parentName[1] === "setting"
          ? parentName[1]
          : parentName.length > 3 &&
            parentName[2]?.charAt(0).toLocaleUpperCase() +
              parentName[2]?.slice(
                1,
                parentName[parentName.length - 2].length
              )) || location.pathname.split("/")[1];

      navigate(location.pathname, {
        state: parentName,
      });
    }
    return () => {
      isRedirect = true;
    };
  }, []);
  return (
    <Routes>
      <Route element={<AppLayout />}>
        {/* private routes put it  here */}

        {PrivateRoutes}
      </Route>

      {PublicRoutes}
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
